// firestore/createUserFromLink.js

import { createUserDoc } from "./createUserDoc";


/**
 * Creates a user document from email link sign-in.
 * @param {string} uid - The user's UID.
 * @param {Object} additionalData - Additional user data.
 * @returns {Promise<void>}
 */
export async function createUserFromLink(uid, additionalData) {
  try {
    // Assuming uid is not used as the document ID since we're using email as identifier
    await createUserDoc(additionalData.email, additionalData);
  } catch (error) {
    console.error('Error creating user from link:', error);
    throw error;
  }
}